import { atom } from 'jotai';

export type TSubmittingNavigationState = Readonly<{
  isSubmitting: boolean;
}>;

export const INITIAL_DIRTY_NAVIGATION_STATE = {
  isSubmitting: false,
};

const submittingNavigationAtom = atom<TSubmittingNavigationState>(INITIAL_DIRTY_NAVIGATION_STATE);

export { submittingNavigationAtom };
